import React, { useState, useEffect } from "react"
import VideoWrapper from "@/components/VideoWrapper/VideoWrapper"
import Modal from "@/components/core/Modal/Modal"
import { preventBodyScroll } from "@/utils/helper"
import styles from "@/components/VideoWrapper/index.module.scss"

const VideoModal = props => {
  const { isWhiteCloseIcon = "", videoId = "", onClose = () => {} } = props
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    setShowModal(true)
    preventBodyScroll(true)
    return () => preventBodyScroll(false)
  }, [])

  const closeModal = () => {
    setShowModal(false)
    onClose()
    preventBodyScroll(false)
  }

  return (
    <>
      {showModal && (
        <div className={styles.videoModalWrapper}>
          <div className="video-modal__content">
            <Modal
              onModalClose={closeModal}
              showModal={showModal}
              isWhiteCloseIcon={isWhiteCloseIcon}
            >
              <VideoWrapper
                videoId={videoId}
                isPopup={showModal}
                width="100%"
              />
            </Modal>
          </div>
        </div>
      )}
    </>
  )
}

export default VideoModal
